/**
 * directives.slider Module
 *
 * Description
 */
var app = angular.module('directives.sliderServices');
/*TODO сделать динамическое количество сервисов*/
app.directive('sliderServices', ['$timeout', '$window', function ($timeout, $window) {
    return {
        priority: 100,
        terminal: true,
        restrict: 'AE',
        template: require('../templates/index.html'),
        controller: [
            '$scope',
            '$element',
            '$location',
            '$state',
            'ModelSrv',
            'OneClickPayment',
            function ($scope, $element, $location, $state, ModelSrv, OneClickPayment) {
                var Slider = {
                    serviceWidth: 274,
                    itemCounts: 3,
                    currentService: 0,
                    service: [],
                    model: {
                        cardA: '',
                        cardB: '',
                        summ: '',
                        setModel: function () {
                            ModelSrv.setCardA(Slider.model.cardA);
                            ModelSrv.setCardB(Slider.model.cardB);
                            ModelSrv.setSumm(Slider.model.summ);
                        }
                    },
                    clickService: function (index) {
                        var newServiceWidth;
                        if (index === Slider.currentService) {
                            return;
                        } else if (index - Slider.currentService > 0) {
                            newServiceWidth = (index - Slider.currentService < Slider.itemCounts) || Slider.currentService == 1 ? Slider.serviceWidth : Slider.serviceWidth * (5 - Slider.itemCounts);
                            if (Slider.service[5 - Slider.itemCounts].left <= 0) {
                                Slider.currentService = index;
                                return;
                            }
                        } else {
                            newServiceWidth = (index - Slider.currentService > -1 * Slider.itemCounts) || (Slider.currentService == 3 && index == 0) ? -1 * Slider.serviceWidth : -1 * Slider.serviceWidth * (5 - Slider.itemCounts);
                            if (Slider.service[0].left >= 0) {
                                Slider.currentService = index;
                                return;
                            }
                        }

                        Slider.service.forEach(function (item, index) {
                            item.left -= newServiceWidth;
                        });
                        Slider.currentService = index;
                    },
                    prevService: function () {
                        Slider.currentService = Slider.currentService <= 0 ? 0 : --Slider.currentService;
                        if (Slider.service[0].left !== 0) {
                            Slider.service.forEach(function (item, index) {
                                item.left += Slider.serviceWidth;
                            });
                        }
                    },
                    nextService: function () {
                        var index = Slider.itemCounts == 3 ? 2 : 1;
                        Slider.currentService = Slider.currentService >= 4 ? 4 : ++Slider.currentService;
                        if (Slider.service[index].left !== 0) {
                            Slider.service.forEach(function (item, index) {
                                item.left -= Slider.serviceWidth;
                            });
                        }
                    },
                    chooseService: function (path, inputForm) {
                        if (!path) {
                            return alert('Данный функционал доступен только для зарегистрированных пользователей.');

                        } else if (path === 'pages.cardtransfer') {
                            OneClickPayment.doOneClickPayment(inputForm);

                        } else if (path === 'pages.phonepayment') {
                            var serviceId = 0;

                            if (inputForm.phone) {
                                serviceId = OneClickPayment.phoneCodeFinder(inputForm.phone);

                                if (!serviceId) {
                                    return alert('По коду телефона не найден провайдер мобильной связи');
                                }

                            } else if (inputForm) {

                            }



                        } else {
                            return alert('Error: Unknown path');
                        }

                        $state.go(path);

                        if (inputForm) {
                            if (!OneClickPayment.doOneClickPayment(inputForm)) {
                                return;
                            }
                        } else {

                        }


                    }
                };

                $scope.Slider = Slider;

                var w = angular.element($window);
                $scope.$watch(function () {
                    return {
                        'height': w[0].innerHeight,
                        'width': w[0].innerWidth
                    };
                }, function (newValue, oldValue) {

                    Slider.itemCounts = Math.floor((newValue.width - 260) / 280) >= 3 ? Math.floor((newValue.width - 260) / 280) : 3;
                    Slider.serviceWidth = ((newValue.width - (260 + Slider.itemCounts * 234)) / (Slider.itemCounts - 1)) >= 40 ? ((newValue.width - (260 + Slider.itemCounts * 234)) / (Slider.itemCounts - 1)) + 234 : 274;
                    Slider.service = [
                    {
                        left: 0
                    },
                    {
                        left: Slider.serviceWidth
                    },
                    {
                        left: 2 * (Slider.serviceWidth)
                    },
                    {
                        left: 3 * (Slider.serviceWidth)
                    },
                    {
                        left: 4 * (Slider.serviceWidth)
                    }];

                }, true);

                w.bind('resize', function () {
                    $scope.$apply();
                });
            }
        ]
    };
}]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderServices/directives/directive.js
 ** module id = 225
 ** module chunks = 1
 **/